import * as Sentry from '@sentry/nextjs'

const STORAGE_KEYS = {
	SLUG: 'ga4LastAmbulanceSlug',
	NAME: 'ga4LastAmbulanceName'
} as const

/** Persists the last virtual ambulance slug (and optional display name) from navigation (last wins). */
export function saveGa4LastAmbulanceSlug(slug: string, name?: string): void {
	if (typeof window === 'undefined' || !slug.trim()) return
	try {
		const prevSlug = sessionStorage.getItem(STORAGE_KEYS.SLUG)
		sessionStorage.setItem(STORAGE_KEYS.SLUG, slug)
		if (name?.trim()) {
			sessionStorage.setItem(STORAGE_KEYS.NAME, name.trim())
		} else if (prevSlug !== slug) {
			sessionStorage.removeItem(STORAGE_KEYS.NAME)
		}
	} catch (error) {
		Sentry.captureException(error)
	}
}

export function getGa4LastAmbulanceSlug(): string | null {
	if (typeof window === 'undefined') return null
	try {
		return sessionStorage.getItem(STORAGE_KEYS.SLUG)
	} catch (error) {
		Sentry.captureException(error)
		return null
	}
}

export function getGa4LastAmbulanceName(): string | null {
	if (typeof window === 'undefined') return null
	try {
		return sessionStorage.getItem(STORAGE_KEYS.NAME)
	} catch (error) {
		Sentry.captureException(error)
		return null
	}
}

/** Clears stored slug/name after a successful purchase so the next order does not reuse it. */
export function clearGa4LastAmbulanceSlug(): void {
	if (typeof window === 'undefined') return
	try {
		sessionStorage.removeItem(STORAGE_KEYS.SLUG)
		sessionStorage.removeItem(STORAGE_KEYS.NAME)
	} catch (error) {
		Sentry.captureException(error)
	}
}
